const mutations = {
  CATEGORIES (state, data) {
    state.categories = data
  },
  CITY (state, data) {
    state.city = data
  },
  CURRENT_PRODUCT(state, data) {
    state.currentProduct = data
  },
  PRODUCTS_SEARCH(state, data) {
    state.productsSearch = data;
  },
  PRODUCTS_SUGGESTIONS(state, data) {
    state.productsSuggestions = data;
  },
  IS_LOADING_CATEGORIES(state, data) {
    state.isLoadingCategories = data;
  },
  CURRENT_SUPER_CATEGORY(state, data) {
    state.currentSuperCategory = data;
  },
  CURRENT_CATEGORY(state, data) {
    state.currentCategory = data;
  },
  PRODUCT_RECOMMENDATIONS(state, data) {
    state.productRecommendations = data;
  }
}

export default mutations
